import * as z from "zod";

export const getNarvarIntegration = {
  name: "getNarvarIntegration" as const,
  input: z.object({}),
  output: z.object({
    narvarIntegration: z.optional(
      z.object({ enabled: z.boolean(), username: z.string() }),
    ),
  }),
};

export const setNarvarIntegration = {
  name: "setNarvarIntegration" as const,
  input: z.object({
    username: z.string().trim().min(1, "Username is required"),
    password: z.string().min(1, "Password is required"),
  }),
  output: z.object({}),
};

export const updateNarvarIntegration = {
  name: "updateNarvarIntegration" as const,
  input: z.object({
    username: z.string().trim().min(1, "Username is required").optional(),
    password: z.string().min(1, "Password is required").optional(),
  }),
  output: z.object({}),
};

export const disconnectNarvarIntegration = {
  name: "disconnectNarvarIntegration" as const,
  input: z.object({}),
  output: z.object({}),
};
